import axios from 'axios';
import { API_BASE_URL } from '../config/api.js';
import { clearAuthStorage, shouldForceLogoutOn401 } from '../utils/tokenUtils.js';
const API = axios.create({ baseURL: `${API_BASE_URL}/api` });

// Interceptor za zahteve koji dodaje token u header
API.interceptors.request.use((req) => {
  const profile = localStorage.getItem('profile');
  if (profile) {
    try {
      const parsedProfile = JSON.parse(profile);
      if (parsedProfile.token) {
        req.headers.Authorization = `Bearer ${parsedProfile.token}`;
      }
    } catch (e) {
      // Silent fail
    }
  }
  return req;
});

// Interceptor za odgovore koji provjerava da li je token istekao
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Ne logout-uj korisnika za verify-access endpoint - TenantDashboard ?e to obraditi
    const isVerifyAccessEndpoint = error.config?.url?.includes('/verify-access');
    
    // Proveri da li je ovo auth endpoint (login, register, itd.)
    const isAuthEndpoint = error.config?.url?.includes('/auth/') || 
                          error.config?.url?.includes('/signin') || 
                          error.config?.url?.includes('/signup') ||
                          error.config?.url?.includes('/register');
    
    // Proveri da li je ovo javni analytics endpoint (ne zahteva autentifikaciju)
    const isAnalyticsTrackingEndpoint = error.config?.url?.includes('/analytics/track/');
    
    // Proveri da li smo ve? na login stranici ili na javnim stranicama
    const isOnLoginPage = window.location.pathname.includes('/auth') || 
                         window.location.pathname.includes('/login') ||
                         window.location.pathname.includes('/forgot-password') ||
                         window.location.pathname.includes('/reset-password');
    
    // Proveri da li smo na home stranici ili drugim javnim stranicama
    const isOnPublicPage = window.location.pathname === '/' || 
                          window.location.pathname === '/home' ||
                          window.location.pathname === '/tutorials' ||
                          window.location.pathname.startsWith('/verify-email') ||
                          window.location.pathname.startsWith('/superadmin');
    
    if (error.response && shouldForceLogoutOn401(error) && !isVerifyAccessEndpoint && !isAuthEndpoint && !isAnalyticsTrackingEndpoint && !isOnLoginPage && !isOnPublicPage) {
      
      // Proveri tip korisnika pre brisanja profila da bismo znali gde da redirect-ujemo
      let userRole = 'company';
      let loginPath = '/auth?role=company&type=login';
      
      try {
        const profile = localStorage.getItem('profile');
        if (profile) {
          const parsedProfile = JSON.parse(profile);
          // Proveri razli?ite na?ine na koje se role mo?e ?uvati
          if (parsedProfile.result?.role) {
            userRole = parsedProfile.result.role;
          } else if (parsedProfile.result?.userType) {
            userRole = parsedProfile.result.userType;
          } else if (parsedProfile.role) {
            userRole = parsedProfile.role;
          } else if (parsedProfile.userType) {
            userRole = parsedProfile.userType;
          }
          
          // Postavi odgovaraju?i login path
          if (userRole === 'worker' || userRole === 'radnik') {
            loginPath = '/auth?role=worker&type=login';
          } else if (userRole === 'partner') {
            loginPath = '/auth?role=partner&type=login';
          } else if (userRole === 'user' || userRole === 'korisnik') {
            loginPath = '/auth?role=user&type=login';
          } else {
            loginPath = '/auth?role=company&type=login';
          }
        }
      } catch (e) {
        console.error('Error determining user role for redirect:', e);
      }
      
      // Token je istekao ili nije validan
      clearAuthStorage();
      
      // Proveri da li poruka ve? postoji da ne bi kreirali vi?e poruka
      if (document.getElementById('session-message')) {
        return Promise.reject(error);
      }
      
      // Create spinner with countdown message
      let countdown = 3;
      const messageDiv = document.createElement('div');
      messageDiv.id = 'session-message';
      messageDiv.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.9);
        color: white;
        padding: 30px;
        border-radius: 8px;
        z-index: 9999;
        text-align: center;
        font-family: sans-serif;
        min-width: 300px;
      `;

      // Create spinner element
      const spinner = document.createElement('div');
      spinner.style.cssText = `
        width: 40px;
        height: 40px;
        margin: 0 auto 20px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      `;

      // Add keyframes for spinner animation
      const styleSheet = document.createElement('style');
      styleSheet.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(styleSheet);

      messageDiv.appendChild(spinner);
      const textDiv = document.createElement('div');
      textDiv.textContent = `Sesija je istekla. Preusmeravanje na login stranicu za ${countdown} sekundi...`;
      messageDiv.appendChild(textDiv);
      document.body.appendChild(messageDiv);

      const countdownInterval = setInterval(() => {
        countdown--;
        if (countdown > 0) {
          textDiv.textContent = `Sesija je istekla. Preusmeravanje na login stranicu za ${countdown} sekundi...`;
        } else {
          clearInterval(countdownInterval);
          messageDiv.remove();
          window.location.href = loginPath;
        }
      }, 1000);
    }
    return Promise.reject(error);
  }
);

// Auth
export const signIn = (formData) => API.post('/auth/company/signin', formData);
export const signUp = (formData) => API.post('/auth/signup', formData);
export const signUpCompany = (formData) => API.post('/auth/registercompany', formData);

// Jobs
export const createJob = (jobData) => {
  return API.post('/jobs', jobData);
};

/**
 * @param {string | object} arg - string businessType ili { businessType, fetchAll, startDate, endDate, includeUnscheduled }
 */
export const getJobs = (arg) => {
  const params = new URLSearchParams();
  if (arg == null || arg === '') {
    params.set('fetchAll', 'true');
    return API.get(`/jobs?${params.toString()}`);
  }
  if (typeof arg === 'string') {
    if (arg) params.set('businessType', arg);
    params.set('fetchAll', 'true');
    return API.get(`/jobs?${params.toString()}`);
  }
  if (arg.fetchAll) {
    if (arg.businessType) params.set('businessType', arg.businessType);
    params.set('fetchAll', 'true');
    if (arg.archiveOnly) params.set('archiveOnly', 'true');
    if (arg.assignedToFilter) params.set('assignedToFilter', String(arg.assignedToFilter));
    return API.get(`/jobs?${params.toString()}`);
  }
  if (arg.businessType) params.set('businessType', arg.businessType);
  if (arg.startDate) params.set('startDate', arg.startDate);
  if (arg.endDate) params.set('endDate', arg.endDate);
  if (arg.includeUnscheduled === false) params.set('includeUnscheduled', 'false');
  if (arg.archiveOnly) params.set('archiveOnly', 'true');
  if (arg.assignedToFilter) params.set('assignedToFilter', String(arg.assignedToFilter));
  return API.get(`/jobs?${params.toString()}`);
};

export const getWorkloadJobCount = (businessType) => {
  const params = new URLSearchParams();
  params.set('countOnly', 'true');
  params.set('fetchAll', 'true');
  if (businessType) params.set('businessType', businessType);
  return API.get(`/jobs?${params.toString()}`);
};

export const getDashboardJobStats = (businessType) => {
  const params = new URLSearchParams();
  params.set('dashboardStats', 'true');
  params.set('fetchAll', 'true');
  if (businessType) params.set('businessType', businessType);
  return API.get(`/jobs?${params.toString()}`);
};

export const getJob = (id) => API.get(`/jobs/${id}`);
export const updateJob = ({ id, jobData }) => API.patch(`/jobs/${id}`, jobData);
export const deleteJob = (id) => API.delete(`/jobs/${id}`);
export const extractJobDataFromMessage = (message) => API.post('/jobs/extract-from-message', { message });
export const extractJobDataFromImages = (formData) => {
  return API.post('/jobs/extract-from-images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const analyzeDeviceIssue = (deviceData) => API.post('/jobs/analyze-issue', deviceData);
export const fetchServiceArrivalMethods = () => API.get('/jobs/arrival-methods');
export const createServiceArrivalMethod = (data) => API.post('/jobs/arrival-methods', data);
export const getAiUsageStatus = () => API.get('/ai-import/usage-status');
export const getAiModelSettings = () => API.get('/ai-import/model-settings');
export const updateAiModelSettings = (data) => API.patch('/ai-import/model-settings', data);

// Workers
export const fetchWorkers = () => API.get('/worker');
export const fetchWorker = (id) => API.get(`/worker/${id}`);
export const createWorker = (workerData) => API.post('/worker', workerData);
export const updateWorker = (id, workerData) => API.patch(`/worker/${id}`, workerData);
export const deleteWorker = (id) => API.delete(`/worker/${id}`);

// Partners
export const fetchPartners = () => API.get('/partner');
export const fetchPartner = (id) => API.get(`/partner/${id}`);
export const createPartner = (partnerData) => API.post('/partner', partnerData);
export const updatePartner = ({ id, partnerData }) => API.put(`/partner/${id}`, partnerData);
export const deletePartner = (id) => API.delete(`/partner/${id}`);

// Teams
export const fetchTeams = () => API.get('/team');
export const fetchTeam = (id) => API.get(`/team/${id}`);
export const fetchTeamShareRules = () => API.get('/team/share-rules');
export const previewTeamShares = (memberIds) =>
  API.post('/team/preview-shares', { memberIds });
export const createTeam = (teamData) => API.post('/team', teamData);
export const updateTeam = (id, teamData) => {
  return API.put(`/team/${id}`, teamData);
};
export const deleteTeam = (id) => API.delete(`/team/${id}`);

// WebShop
export const getWebShopSettings = () => API.get('/webshop/settings');
export const createWebShopSettings = (settingsData) => API.post('/webshop/settings', settingsData);
export const updateWebShopSettings = (settingsData) => API.put('/webshop/settings', settingsData);
export const getWebShopBySlug = (slug) => API.get(`/webshop/public/${slug}`);

// WebShop Products (Admin)
export const getWebShopProducts = () => API.get('/webshop/products');
export const createWebShopProduct = (productData) => API.post('/webshop/products', productData);
export const updateWebShopProduct = (productId, productData) => API.put(`/webshop/products/${productId}`, productData);
export const deleteWebShopProduct = (productId) => API.delete(`/webshop/products/${productId}`);

// WebShop Categories (Admin)
export const getWebShopCategories = () => API.get('/webshop/categories');
export const createWebShopCategory = (categoryData) => API.post('/webshop/categories', categoryData);
export const updateWebShopCategory = (categoryId, categoryData) => API.put(`/webshop/categories/${categoryId}`, categoryData);
export const deleteWebShopCategory = (categoryId) => API.delete(`/webshop/categories/${categoryId}`);

// WebShop Orders (Admin)
export const getWebShopOrders = () => API.get('/webshop/orders');
export const getWebShopOrder = (orderId) => API.get(`/webshop/orders/${orderId}`);
export const updateWebShopOrderStatus = (orderId, status) => API.put(`/webshop/orders/${orderId}/status`, { status });

// Services hierarchy
export const fetchDeviceCategories = () => API.get('/services/device-categories');
export const createDeviceCategory = (categoryData) => API.post('/services/device-categories', categoryData);
export const updateDeviceCategory = ({ id, categoryData }) => API.put(`/services/device-categories/${id}`, categoryData);
export const deleteDeviceCategory = (id) => API.delete(`/services/device-categories/${id}`);

export const fetchDeviceTypes = () => API.get('/services/device-types');
export const createDeviceType = (typeData) => API.post('/services/device-types', typeData);
export const updateDeviceType = ({ id, typeData }) => API.put(`/services/device-types/${id}`, typeData);
export const deleteDeviceType = (id) => API.delete(`/services/device-types/${id}`);

export const fetchServicesList = () => API.get('/services');
export const createServiceItem = (serviceData) => API.post('/services', serviceData);
export const updateServiceItem = ({ id, serviceData }) => API.put(`/services/${id}`, serviceData);
export const deleteServiceItem = (id) => API.delete(`/services/${id}`);

// AI Business
export const fetchAIBusinessIdeas = () => API.get('/ai-business');
export const createAIBusinessIdea = (ideaData) => API.post('/ai-business', ideaData);
export const updateAIBusinessIdea = ({ id, ideaData }) => API.put(`/ai-business/${id}`, ideaData);
export const deleteAIBusinessIdea = (id) => API.delete(`/ai-business/${id}`);
export const respondToAIBusinessIdea = ({ id, status, note }) =>
  API.post(`/ai-business/${id}/respond`, { status, note });

// Company
export const fetchCompanyById = (id) => API.get(`/company/${id}`);
export const updateCompanyById = ({ id, companyData }) => API.patch(`/company/${id}`, companyData);

// Models
export const fetchModels = () => {
  return API.get('/models');
};
export const fetchModel = (id) => {
  return API.get(`/models/${id}`);
};
export const createModel = (modelData) => {
  return API.post('/models', modelData);
};
export const updateModel = ({ id, modelData }) => {
  return API.put(`/models/${id}`, modelData);
};
export const deleteModel = (id) => {
  return API.delete(`/models/${id}`);
};

// Clients
export const fetchClients = () => {
  return API.get('/client');
};
export const fetchClient = (id) => {
  return API.get(`/client/${id}`);
};
export const createClient = (clientData) => {
  return API.post('/client', clientData);
};
export const updateClient = ({ id, clientData }) => {
  return API.put(`/client/${id}`, clientData);
};
export const deleteClient = (id) => {
  return API.delete(`/client/${id}`);
};

// Spare Parts
export const fetchSpareParts = () => API.get('/sparePart');
export const fetchSparePart = (id) => API.get(`/sparePart/${id}`);
export const createSparePart = (sparePartData) => API.post('/sparePart', sparePartData);
export const updateSparePart = ({ id, sparePartData }) => API.put(`/sparePart/${id}`, sparePartData);
export const deleteSparePart = (id) => API.delete(`/sparePart/${id}`);
export const getSparePartWarehouseTransactions = (params) => API.get('/sparePart/warehouse/transactions', { params });
export const createSparePartWarehouseInput = (transactionData) => API.post('/sparePart/warehouse/input', transactionData);
export const createSparePartWarehouseOutput = (transactionData) => API.post('/sparePart/warehouse/output', transactionData);

export const fetchStockArrivalSources = () => API.get('/inventory/arrival-sources');
export const createStockArrivalSource = (data) => API.post('/inventory/arrival-sources', data);
export const fetchStockSuppliers = () => API.get('/inventory/suppliers');
export const createStockSupplier = (data) => API.post('/inventory/suppliers', data);
export const fetchAssetCategories = () => API.get('/inventory/asset-categories');
export const createAssetCategory = (data) => API.post('/inventory/asset-categories', data);

// User/Company Profile
// baseURL je ve? .../api ? bez duplog prefiksa /api/ (ina?e /api/api/...)
export const getUser = () => API.get('/company/profile');
export const getCompany = () => API.get('/company/profile');

export const getBillingSummary = (params) => API.get('/finance/billing-summary', { params });
export const getMyQuarterlyInvoices = () => API.get('/finance/quarterly-invoices');
export const getMyQuarterlyInvoicePdf = (id) =>
  API.get(`/finance/quarterly-invoices/${id}/pdf`, { responseType: 'blob' });
export const patchBillingPlan = (packageNum) => API.patch('/finance/plan', { package: packageNum });

// Super Admin
export const getSuperAdminStats = () => API.get('/superadmin/stats');
export const getSuperAdminInvoicing = () => API.get('/superadmin/invoicing');
export const putSuperAdminEurRate = (eurToRsdManual) =>
  API.put('/superadmin/invoicing/eur-rate', { eurToRsdManual });
export const patchQuarterlyInvoicePaid = (id, body = {}) =>
  API.patch(`/superadmin/invoicing/quarterly/${id}/paid`, body);
export const postQuarterlyInvoiceOfficialEmail = (id) =>
  API.post(`/superadmin/invoicing/quarterly/${id}/official-email`, {});
export const getQuarterlyInvoicePdfSuperAdmin = (id) =>
  API.get(`/superadmin/invoicing/quarterly/${id}/pdf`, { responseType: 'blob' });
export const getAllCompanies = () => API.get('/superadmin/companies');
export const getSuperAdminRegistrationAlerts = (since) =>
  API.get('/superadmin/registration-alerts', { params: since ? { since } : {} });
export const getRegistrationAttempts = (params = {}) =>
  API.get('/superadmin/registration-attempts', { params });
export const getCompanyDetails = (companyId) => API.get(`/superadmin/companies/${companyId}`);
export const getCompanyClients = (companyId, page = 1, limit = 100) => API.get(`/superadmin/companies/${companyId}/clients`, { params: { page, limit } });
export const getCompanyOrders = (companyId) => API.get(`/superadmin/companies/${companyId}/orders`);
export const updateCompanyBySuperAdmin = ({ companyId, companyData }) => API.put(`/superadmin/companies/${companyId}`, companyData);
export const deleteCompanyBySuperAdmin = (companyId) => API.delete(`/superadmin/companies/${companyId}`);
export const sendGlobalNotification = (notificationData) => API.post('/superadmin/notifications', notificationData);
export const getSentNotifications = () => API.get('/superadmin/notifications');

// Business Contacts (Super Admin)
export const getBusinessContacts = (page = 1, limit = 10) => API.get('/superadmin/business-contacts', { params: { page, limit } });
export const getBusinessContact = (id) => API.get(`/superadmin/business-contacts/${id}`);
export const createBusinessContact = (contactData) => API.post('/superadmin/business-contacts', contactData);
export const updateBusinessContact = ({ id, contactData }) => API.put(`/superadmin/business-contacts/${id}`, contactData);
export const deleteBusinessContact = (id) => API.delete(`/superadmin/business-contacts/${id}`);
export const extractBusinessContactDataFromText = (text) => API.post('/superadmin/business-contacts/extract-from-text', { text });
export const exportBusinessContactsToCSV = () => API.get('/superadmin/business-contacts/export-csv', { responseType: 'blob' });
export const importBusinessContactsFromCSV = (contactsData) => API.post('/superadmin/business-contacts/import-csv', { contacts: contactsData });

// Marketing consent (newsletter opt-in)
export const getMarketingConsents = (page = 1, limit = 20, params = {}) =>
  API.get('/superadmin/marketing-consents', { params: { page, limit, ...params } });
export const createMarketingConsent = (data) => API.post('/superadmin/marketing-consents', data);
export const updateMarketingConsent = ({ id, data }) => API.put(`/superadmin/marketing-consents/${id}`, data);
export const optOutMarketingConsent = (id) => API.post(`/superadmin/marketing-consents/${id}/opt-out`);
export const deleteMarketingConsent = (id) => API.delete(`/superadmin/marketing-consents/${id}`);
export const getFaultReports = (page = 1, limit = 20, params = {}) =>
  API.get('/superadmin/fault-reports', { params: { page, limit, ...params } });
export const getFaultReportAttempts = () => API.get('/superadmin/fault-report-attempts');
export const patchFaultReport = (id, data) => API.patch(`/superadmin/fault-reports/${id}`, data);
export const deleteFaultReport = (id) => API.delete(`/superadmin/fault-reports/${id}`);

// Campaigns API
export const getCampaigns = (page = 1, limit = 10) => API.get('/superadmin/campaigns', { params: { page, limit } });
export const getCampaign = (id) => API.get(`/superadmin/campaigns/${id}`);
export const createCampaign = (campaignData) => API.post('/superadmin/campaigns', campaignData);
export const updateCampaign = ({ id, campaignData }) => API.put(`/superadmin/campaigns/${id}`, campaignData);
export const deleteCampaign = (id) => API.delete(`/superadmin/campaigns/${id}`);
export const sendCampaign = (id) => API.post(`/superadmin/campaigns/${id}/send`);
export const sendBulkEmail = (emailData) => API.post('/superadmin/campaigns/bulk-email', emailData);

// Email campaigns (with groups and follow-up)
export const createEmailCampaign = (campaignData) => API.post('/superadmin/email-campaigns', campaignData);
export const getEmailCampaigns = () => API.get('/superadmin/email-campaigns');
export const getEmailCampaign = (id) => API.get(`/superadmin/email-campaigns/${id}`);
export const sendFirstEmailToGroup = (campaignId, groupNumber) => API.post('/superadmin/email-campaigns/send-first', { campaignId, groupNumber });
export const sendFollowUpEmailToGroup = (campaignId, groupNumber) => API.post('/superadmin/email-campaigns/send-followup', { campaignId, groupNumber });
export const getEmailTracking = (campaignId) => API.get(`/superadmin/email-campaigns/${campaignId}/tracking`);

// Email groups (static groups)
export const createEmailGroup = (groupData) => API.post('/superadmin/email-groups', groupData);
export const getEmailGroups = () => API.get('/superadmin/email-groups');
export const getEmailGroup = (id) => API.get(`/superadmin/email-groups/${id}`);
export const updateEmailGroup = ({ id, groupData }) => API.put(`/superadmin/email-groups/${id}`, groupData);
export const deleteEmailGroup = (id) => API.delete(`/superadmin/email-groups/${id}`);
export const sendFirstEmailToEmailGroup = (groupId, subject, body, images) => API.post('/superadmin/email-groups/send-first', { groupId, subject, body, images });
export const sendFollowUpEmailToEmailGroup = (groupId, subject, body, images) => API.post('/superadmin/email-groups/send-followup', { groupId, subject, body, images });
export const getEmailGroupsStats = () => API.get('/superadmin/email-groups/stats');
export const uploadEmailImages = (formData) => API.post('/superadmin/email-groups/upload-images', formData, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

// Phone groups (static groups for Viber)
export const createPhoneGroup = (groupData) => API.post('/superadmin/phone-groups', groupData);
export const getPhoneGroups = () => API.get('/superadmin/phone-groups');
export const getPhoneGroup = (id) => API.get(`/superadmin/phone-groups/${id}`);
export const updatePhoneGroup = ({ id, groupData }) => API.put(`/superadmin/phone-groups/${id}`, groupData);
export const deletePhoneGroup = (id) => API.delete(`/superadmin/phone-groups/${id}`);
export const exportPhoneGroupToCSV = (id) => API.get(`/superadmin/phone-groups/${id}/export`, { responseType: 'blob' });
export const getPhoneGroupsStats = () => API.get('/superadmin/phone-groups/stats');

// User Notification API
const userNotificationsInflight = new Map();

function serializeNotificationParams(params) {
  if (params == null || typeof params !== 'object') return '{}';
  const sorted = {};
  Object.keys(params)
    .sort()
    .forEach((k) => {
      sorted[k] = params[k];
    });
  return JSON.stringify(sorted);
}

/** Isti GET se ?esto ?alje iz NotificationChecker + ParkingBanner (+ StrictMode dupli mount) ? jedan HTTP po parametrima dok traje. */
export const getUserNotifications = (params) => {
  const key = serializeNotificationParams(params);
  const existing = userNotificationsInflight.get(key);
  if (existing) return existing;

  const promise = API.get('/user-notifications', { params }).finally(() => {
    if (userNotificationsInflight.get(key) === promise) {
      userNotificationsInflight.delete(key);
    }
  });
  userNotificationsInflight.set(key, promise);
  return promise;
};

let unreadNotificationCountInflight = null;
export const getUnreadNotificationCount = () => {
  if (unreadNotificationCountInflight) return unreadNotificationCountInflight;
  unreadNotificationCountInflight = API.get('/user-notifications/unread-count').finally(() => {
    unreadNotificationCountInflight = null;
  });
  return unreadNotificationCountInflight;
};
export const createUserNotification = (data) => API.post('/user-notifications', data);
export const createParkingReminder = (data) => API.post('/user-notifications/parking-reminder', data);
export const markNotificationAsRead = (notificationId) => API.patch(`/user-notifications/${notificationId}/read`);
export const markAllNotificationsAsRead = () => API.patch('/user-notifications/read-all');
export const deleteNotification = (notificationId) => API.delete(`/user-notifications/${notificationId}`);
export const getGlobalNotifications = () => API.get('/notifications/all');
export const getTutorialsManifest = () => API.get('/tutorials/manifest');
export const submitTutorialComment = (data) => API.post('/tutorials/comments', data);
export const getApprovedTutorialComments = (params) => API.get('/tutorials/comments', { params });
export const getPendingTutorialComments = () => API.get('/tutorials/comments/pending');
export const getTutorialCommentsAdmin = () => API.get('/tutorials/comments/admin');
export const moderateTutorialComment = (id, data) => API.patch(`/tutorials/comments/${id}/moderate`, data);
export const deleteTutorialComment = (id) => API.delete(`/tutorials/comments/${id}`);
export const createSuperAdmin = (adminData) => API.post('/superadmin/create-admin', adminData);
export const createSuperAdminPublic = (adminData) => API.post('/superadmin/create-admin-public', adminData);

// Commissions
export const getAllCommissions = (params) => API.get('/commissions', { params });
export const getCompanyCommissions = (companyId, params) => API.get(`/commissions/company/${companyId}`, { params });
export const getCommission = (commissionId) => API.get(`/commissions/${commissionId}`);
export const createCommission = (commissionData) => API.post('/commissions', commissionData);
export const updateCommission = (commissionId, updateData) => API.put(`/commissions/${commissionId}`, updateData);
export const deleteCommission = (commissionId) => API.delete(`/commissions/${commissionId}`);

// Inventory - Items
export const getInventoryItems = (params) => API.get('/inventory/items', { params });
export const getInventoryItem = (id) => API.get(`/inventory/items/${id}`);
export const getInventoryStats = (params) => API.get('/inventory/items/stats', { params });
export const createInventoryItem = (itemData) => API.post('/inventory/items', itemData);
export const updateInventoryItem = ({ id, itemData }) => API.put(`/inventory/items/${id}`, itemData);
export const deleteInventoryItem = (id) => API.delete(`/inventory/items/${id}`);

// Inventory - Warehouse Transactions
export const getWarehouseTransactions = (params) => API.get('/inventory/transactions', { params });
export const getTransactionsByJob = (jobId) => API.get(`/inventory/transactions/job/${jobId}`);
export const createInputTransaction = (transactionData) => API.post('/inventory/transactions/input', transactionData);
export const createOutputTransaction = (transactionData) => API.post('/inventory/transactions/output', transactionData);
export const createReturnTransaction = (transactionData) => API.post('/inventory/transactions/return', transactionData);

// Inventory - Customs
export const getCustomsDeclarations = (params) => API.get('/inventory/customs', { params });
export const getCustomsDeclaration = (id) => API.get(`/inventory/customs/${id}`);
export const createCustomsDeclaration = (declarationData) => API.post('/inventory/customs', declarationData);
export const updateCustomsDeclaration = ({ id, declarationData }) => API.put(`/inventory/customs/${id}`, declarationData);
export const deleteCustomsDeclaration = (id) => API.delete(`/inventory/customs/${id}`);

// Inventory - Movements (Withdrawn Items)
export const getWithdrawnItems = (params) => API.get('/inventory/movements', { params });
export const getMovementsByJob = (jobId) => API.get(`/inventory/movements/job/${jobId}`);
export const getWithdrawnItemsStats = (params) => API.get('/inventory/movements/stats', { params });
export const reserveItemForJob = (reservationData) => API.post('/inventory/movements/reserve', reservationData);
export const issueReservedItem = (movementId, data) => API.put(`/inventory/movements/${movementId}/issue`, data);
export const returnItem = (movementId, data) => API.put(`/inventory/movements/${movementId}/return`, data);
export const markMovementAsUsed = (movementId, data) =>
  API.put(`/inventory/movements/${movementId}/used`, data || {});
export const markJobMovementsAsUsed = (jobId) => API.put(`/inventory/movements/job/${jobId}/used`);

// Inventory - Calculations
export const getCalculations = (params) => API.get('/inventory/calculations', { params });

// Payments (for company invoices to clients)
export const getPayments = (params) => API.get('/payments', { params });
export const getPayment = (id) => API.get(`/payments/${id}`);
export const createPayment = (paymentData) => API.post('/payments', paymentData);
export const updatePayment = ({ id, paymentData }) => API.put(`/payments/${id}`, paymentData);
export const markPaymentAsPaid = (id, paymentData) => API.patch(`/payments/${id}/paid`, paymentData);
export const deletePayment = (id) => API.delete(`/payments/${id}`);
export const getPaymentStats = (params) => API.get('/payments/stats', { params });

// Subscription Payments (for app subscription - users pay you)
export const getSubscriptionPayments = (params) => API.get('/subscription-payments', { params });
export const getSubscriptionPayment = (id) => API.get(`/subscription-payments/${id}`);
export const createSubscriptionPayment = (paymentData) => API.post('/subscription-payments', paymentData);
export const markSubscriptionPaymentAsPaid = (id, paymentData) => API.patch(`/subscription-payments/${id}/paid`, paymentData);
export const verifySubscriptionPayment = (id, verified) => API.patch(`/subscription-payments/${id}/verify`, { verified });
export const getSubscriptionPaymentInfo = () => API.get('/subscription-payments/info');
export const getSubscriptionStats = (params) => API.get('/subscription-payments/stats', { params });

// Marketing Messages
export const getMarketingMessages = (type) => {
  const params = type ? { type } : {};
  return API.get('/marketing', { params });
};
export const getMarketingMessage = (id) => API.get(`/marketing/${id}`);
export const createMarketingMessage = (messageData) => API.post('/marketing', messageData);
export const updateMarketingMessage = ({ id, messageData }) => API.put(`/marketing/${id}`, messageData);
export const deleteMarketingMessage = (id) => API.delete(`/marketing/${id}`);
export const sendMarketingMessage = (id) => API.post(`/marketing/${id}/send`);

// Loyalty & Referrals
export const getMyReferralCode = () => API.get('/loyalty/referral-code');
export const getMyReferrals = () => API.get('/loyalty/referrals');
export const getMyDiscountCodes = () => API.get('/loyalty/discount-codes');
export const generateDiscountCodeManually = (month) => API.post('/loyalty/generate-discount-code', { month });
export const generateLoyaltyVoucher = () => API.post('/loyalty/vouchers');

// Analytics
export const getAnalytics = (params) => API.get('/analytics/stats', { params });
export const getVisitsByEmail = (email) => API.get(`/analytics/visits/email/${email}`);
export const deleteVisitsByDateRange = (data) => API.delete('/analytics/visits', { data });
// kvarx marketplace (citizen jobs room ? separate from /jobs)
export const getKvarxCities = () => API.get('/kvarx/locations/cities');
export const getKvarxMarketplaceJobs = (params) => API.get('/kvarx/marketplace/jobs', { params });
export const getKvarxMarketplaceArchive = () => API.get('/kvarx/marketplace/archive');
export const getKvarxMarketplaceStats = () => API.get('/kvarx/marketplace/stats');
export const submitKvarxMarketplaceOffer = (jobId, offerData) =>
  API.post(`/kvarx/marketplace/jobs/${jobId}/offers`, offerData);
export const deleteKvarxMarketplaceOffer = (jobId) =>
  API.delete(`/kvarx/marketplace/jobs/${jobId}/offers`);
export const getMyKvarxMarketplaceOffers = () => API.get('/kvarx/marketplace/offers');
